jQuery(document).ready(function () {
  var $motive = jQuery('.motive-header');
  var $slider = jQuery('.motive-slider');
  var $document = jQuery(document);

  if ($motive.length == 0) {
    var $navigation = jQuery('#main-navigation');
    $navigation.addClass('navigation-white');
    $navigation.data('navigation-style', 'white');
  }

  $document.on('click', '.motive-slider-control .prev-slide', function () {
    $slider.slick('prev');
  });

  $document.on('click', '.motive-slider-control .next-slide', function () {
    $slider.slick('next');
  });

  $document.on('click', '.motive-slider-control .slide-item', function () {
    var $this = jQuery(this);
    var index = $this.data('index');
    $slider.slick('slickGoTo', index);
  });

  $document.on('click', '.motive-video-start', function () {
    var $this = jQuery(this);
    var $video = $this.closest('.motiv-element').find('video').get(0);

    if ($video) {
      $this.closest('.motiv-element').find('.motive-preview-image').hide();
      $video.play();
    }
    var showButton = function() {
      $this.show();
      $this.parent().children('.motive-video-pause').hide();
      $video.removeEventListener('ended', showButton);
    };

    $video.addEventListener('ended', showButton, false);
    $this.hide();
    $this.parent().children('.motive-video-pause').show();
  });
  $document.on('click', '.motive-video-pause', function () {
    var $this = jQuery(this);
    var $video = $this.closest('.motiv-element').find('video').get(0);

    if ($video) {
      $video.pause();
    }

    $this.hide();
    $this.parent().children('.motive-video-start').show();
  });

  $slider.on('beforeChange', function (e, s, o, slide) {
    var $control = $motive.find('.motive-slider-control');
    $control.find('.slide-item').removeClass('active');
    $control.find('[data-index="' + slide + '"]').addClass('active');
  });

  var $slides = $slider.find('.motiv-element');
  $slides.each(function () {
    var $slide = jQuery(this);
    var $video = $slide.find('video').get(0);

    if ($video) {
      var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      if (isSafari) {
        $video.autoplay = true;
      }

      $slide.append('<div class="motive-video-container"><div class="wrap"><div class="motive-video-start"><svg xmlns="http://www.w3.org/2000/svg" width="170.537" height="146.96"> <g transform="translate(15783.128 2518.801)"> <ellipse class="svg-hover" cx="35" cy="34.5" rx="35" ry="34.5" transform="translate(-15721 -2457)" fill="red"/> <path d="M12.855,4.512a3,3,0,0,1,5.2,0L28.318,22.329a3,3,0,0,1-2.6,4.5H5.19a3,3,0,0,1-2.6-4.5Z" transform="translate(-15668.906 -2437.983) rotate(90)" fill="#fff"/> <path d="M-455.324,461.837a77.72,77.72,0,0,1-7.892-34.223,78.058,78.058,0,0,1,78.06-78.057,77.729,77.729,0,0,1,36.646,9.131l-8.261,15.54a60.173,60.173,0,0,0-28.385-7.074,60.462,60.462,0,0,0-60.463,60.46,60.239,60.239,0,0,0,6.113,26.508Z" transform="translate(-15302.115 -2849.764)" fill="none" stroke="#fff" stroke-width="2"/> <path d="M-432.52,463.119A60.373,60.373,0,0,1-457.45,414.21a60.485,60.485,0,0,1,43.8-58.119L-408.8,373a42.877,42.877,0,0,0-31.049,41.206,42.8,42.8,0,0,0,17.67,34.675Z" transform="translate(-15290.284 -2836.357)" fill="none" stroke="#fff" stroke-width="2"/> <path d="M-451.258,428.581a78.073,78.073,0,0,1,76.97-67.192h.6a78.117,78.117,0,0,1,18.714,2.329c.03.009.061.012.091.021.073.018.146.034.22.052h0l.363.1c.116.03.232.061.348.088l.095.027c.079.021.159.043.235.061q1.09.3,2.164.623l.25.073.021.009h.006c.15.046.3.092.449.14q1.813.563,3.589,1.212l.424.156,0,.006a77.952,77.952,0,0,1,9.415,4.236l0,0c.192.1.382.2.571.305h0c.094.052.186.1.278.153l.012.009c.092.049.183.1.272.152h0c.681.372,1.349.76,2.014,1.157.992.589,1.968,1.206,2.933,1.834v0l.04.025h0c1.157.763,2.295,1.544,3.409,2.365l.027.018v0c.4.287.784.586,1.175.882l.259.2q1.433,1.1,2.808,2.274c.4.333.79.677,1.181,1.019v0q1.41,1.245,2.756,2.551l.061.058c.891.867,1.758,1.755,2.609,2.664s1.675,1.84,2.481,2.789v0l.247.281,13.483-11.316a95.449,95.449,0,0,0-73.271-34.168,95.668,95.668,0,0,0-94.729,82.342Z" transform="translate(-15313.322 -2861.593)" fill="none" stroke="#fff" stroke-width="2"/> </g></svg></div><div class="motive-video-pause"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 170.5 147" style="enable-background:new 0 0 170.5 147"><g transform="translate(15783.128 2518.801)"><ellipse class="svg-hover" fill="red" cx="-15686" cy="-2422.5" rx="35" ry="34.5"/><path class="st1" stroke="#FFF" stroke-width="2" fill="none" d="M-15757.4-2387.9c-5.2-10.7-7.9-22.4-7.9-34.2c0-43.1,34.9-78.1,78.1-78.1c0,0,0,0,0,0c12.8,0,25.4,3.1,36.6,9.1l-8.3,15.5c-8.7-4.7-18.5-7.1-28.4-7.1c-33.4,0-60.5,27.1-60.5,60.5c0,9.2,2.1,18.3,6.1,26.5L-15757.4-2387.9z"/><path class="st1" stroke="#FFF" stroke-width="2" fill="none" d="M-15722.8-2373.2c-15.7-11.4-24.9-29.6-24.9-48.9c0-27,17.9-50.7,43.8-58.1l4.9,16.9c-18.4,5.3-31,22.1-31,41.2c0,13.7,6.6,26.6,17.7,34.7L-15722.8-2373.2z"/><path class="st1" stroke="#FFF" stroke-width="2" fill="none" d="M-15764.6-2433c5.4-38.4,38.2-67,77-67.2h0.6c6.3,0,12.6,0.8,18.7,2.3c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0.1l0,0l0.4,0.1c0.1,0,0.2,0.1,0.3,0.1l0.1,0c0.1,0,0.2,0,0.2,0.1c0.7,0.2,1.4,0.4,2.2,0.6l0.3,0.1l0,0h0c0.1,0,0.3,0.1,0.4,0.1c1.2,0.4,2.4,0.8,3.6,1.2l0.4,0.2v0c3.2,1.2,6.4,2.6,9.4,4.2l0,0c0.2,0.1,0.4,0.2,0.6,0.3l0,0c0.1,0.1,0.2,0.1,0.3,0.2l0,0c0.1,0,0.2,0.1,0.3,0.2l0,0c0.7,0.4,1.3,0.8,2,1.2c1,0.6,2,1.2,2.9,1.8l0,0l0,0l0,0c1.2,0.8,2.3,1.5,3.4,2.4l0,0l0,0c0.4,0.3,0.8,0.6,1.2,0.9l0.3,0.2c1,0.7,1.9,1.5,2.8,2.3c0.4,0.3,0.8,0.7,1.2,1l0,0c0.9,0.8,1.9,1.7,2.8,2.6l0.1,0.1c0.9,0.9,1.8,1.8,2.6,2.7c0.9,0.9,1.7,1.8,2.5,2.8l0,0l0.2,0.3l13.5-11.3c-18.2-21.7-45-34.2-73.3-34.2c-47.7,0-88.1,35.1-94.7,82.3L-15764.6-2433z"/><path fill="#FFF" d="M-15696-2409.3c-0.6,0-1.2-0.3-1.6-0.8s-0.7-1.2-0.7-2v-20.8c0-0.8,0.2-1.5,0.7-2s1-0.8,1.6-0.8h4.5c0.6,0,1.2,0.3,1.6,0.8s0.7,1.2,0.7,2v20.8c0,0.8-0.2,1.5-0.7,2s-1,0.8-1.6,0.8H-15696z M-15673.8-2432.9c0-0.8-0.2-1.5-0.7-2s-1-0.8-1.6-0.8h-4.5c-0.6,0-1.2,0.3-1.6,0.8s-0.7,1.2-0.7,2v20.8c0,0.8,0.2,1.5,0.7,2s1,0.8,1.6,0.8h4.5c0.6,0,1.2-0.3,1.6-0.8s0.7-1.2,0.7-2V-2432.9z"/></g></svg></div></div></div>');
    }
  });

  if ($slider.find('.motiv-element').length <= 1) {
    $motive.addClass('count-1');
    $motive.removeClass('no-js');
    return;
  }

  var $control = jQuery('<div class="motive-slider-control"><div class="prev-slide"></div><div class="next-slide"></div></div>');
  $slides.each(function (_i) {
    var i = _i + 1;
    var $this = jQuery(this);
    var title = $this.data('title');
    var index = i < 10 ? "0" + i : i;

    $control.append('<div class="slide-item ' + (_i === 0 ? 'active' : '') + '" data-index="' + _i + '"><span>' + index + '</span><strong>' + title + '</strong></div>')
  });
  $motive.append($control);

  $slider.slick({ arrows: false });
  $motive.removeClass('no-js');
  $motive.removeClass('count-1');
});
